import { apiService } from '../../shared/services/apiService';
import { ChatInfo } from '../interfaces/chatInfo';

const getChatInfo = async () => {
  const resp = await apiService<ChatInfo>('api/chat-info');

  return resp.data;
};

const getCustomerChatContacts = async () => {
  const resp = await apiService('api/chat-contacts');
  return resp.data;
};

const getCoachContactsChatInfo = async (coachId: number) => {
  const resp = await apiService(`api/chat-info/coach/${coachId}/customers`);
  return resp.data;
};

const refreshUsers = async () => {
  await apiService.post<undefined>('api/chat-info/refresh-users', undefined, {
    isRunGlobalSpinner: false,
  });
};

const getChannelId = async (customerId: number) => {
  const params = { recipientId: customerId };

  const resp = await apiService<string>('api/chat-info/channel/id', { params });

  return resp.data;
};

const sendMessage = async (
  message: string,
  recipientsIds: number[],
  attachmentFileIds: number[],
) => {
  const body = { message, recipientsIds, attachmentFileIds };

  const resp = await apiService.post('api/messaging/chat/send-message', body);
  return resp.data;
};

export const chatService = {
  getChatInfo,
  getCustomerChatContacts,
  getCoachContactsChatInfo,
  refreshUsers,
  getChannelId,
  sendMessage,
};
